export default "<app-problem-list-view></app-problem-list-view>\r\n";